import { render, staticRenderFns } from "./BuildStatus.vue?vue&type=template&id=0b754fd0&scoped=true"
import script from "./BuildStatus.vue?vue&type=script&lang=js"
export * from "./BuildStatus.vue?vue&type=script&lang=js"
import style0 from "./BuildStatus.vue?vue&type=style&index=0&id=0b754fd0&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b754fd0",
  null
  
)

export default component.exports